import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClienteService } from "../../services/cliente.service";

// 3rd libraries
import * as moment from 'moment';
import swal from "sweetalert2";
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Component({
  selector: 'app-retencion-reportes',
  templateUrl: './retencion-reportes.component.html',
  styleUrls: ['./retencion-reportes.component.scss']
})
export class RetencionReportesComponent implements OnInit {
  reporteForm: FormGroup
  beginDate = moment(new Date()).format('YYYY-MM-DD');
  endDate = moment(new Date()).format('YYYY-MM-DD');
  maxDate = moment().endOf('month').format('YYYY-MM-DD');
  beginLimitDate = moment(this.beginDate).subtract(6, 'months').format('YYYY-MM-DD');
  estadoIniciativa='Activo'
  constructor(private clienteservice: ClienteService,
    private ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit(): void {
  }
  showNotification(title, message) {
    swal
      .fire({
        title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {});
  }
}
